export const environment = {
  production: true,
  apiUrl: 'https://bizidev-biziclick.tourvisio.com',
  subscriptionApiUrl: 'https://subdev-biziclick.tourvisio.com',
  parameterApiUrl: 'https://parameterdev-biziclick.tourvisio.com',
  btmApiUrl: 'https://btmdev-biziclick.tourvisio.com',
  clientKey:'test',
  clientSecret:'test',
  googleMapsApiKey: "AIzaSyAqMsGzggHaStu1a-NsCiDLuzVM_FY-A3I",
  googleMapId: "7f2f64735f057e536c1ae57c"
};



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/environments/environment.ts